<template lang="pug">

	.animated.fadeIn
		b-list-group(v-if="sessFilteredByDate(date).length>0" v-for="(date,key) in _datesRange" :key="key")
			h5.mb-3 {{ date|dateFormat('d mmmm') }}
			b-list-group.mb-4
				sessionsListItem(v-for="session in sessFilteredByDate(date)" :key="session.id" :_sessionItem="session" :_participantID="_participantID" :_toggle="toggle")

		b-list-group(v-if="sessWithNoDate.length>0")
			h5.mb-3 Дата и время не заданы
			b-list-group.mb-4
				sessionsListItem(v-for="session in sessWithNoDate" :key="session.id" :_sessionItem="session" :_participantID="_participantID" :_toggle="toggle")

</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import sessionsListItem from './sessionsListItem'

	export default {
		name: 'sessions-component',
		props: ['sess', 'eventID', '_participantID', '_datesRange'],
		data: () => ({
			dateRegExp: "HH:MM",
			ppntLoaded: false,
		}),
		components:{
			sessionsListItem
		},
		computed: {
			...mapState(['myParticipant', 'event']),
			sessWithNoDate(){ return this.sess.filter( ({start_timestamp}) => !start_timestamp ); },
		},
		methods: {
			...mapActions(['getMyParticipant']),
			...mapActions(['addSessionToSchedule', 'removeSessionFromSchedule']),

			sessFilteredByDate(date){
				return this.sess.filter( ({start_timestamp}) =>
					this.$options.filters.dateFormat(start_timestamp,'d mmmm')=== this.$options.filters.dateFormat(date,'d mmmm'))
			},

			async updateContext(){
				this._participantID && await this.$store.dispatch('getMyParticipant', {id: this._participantID});
			},
			async toggle(e,sessionId,remove=false){
				e.preventDefault();
				remove
					? await this.$store.dispatch('removeSessionFromSchedule', { id:sessionId, event:this.eventID })
					: await this.$store.dispatch('addSessionToSchedule', { id:sessionId, event:this.eventID });

				await this.updateContext();
			}
		},
		beforeMount(){
			this.updateContext();
		}
	}
</script>

<style scoped>

</style>
